import { type ContentData } from '../constants/types/checkout-page';
import Page from './page';

export type PageType = {
  contentData: ContentData;
};

export default class CheckoutPage extends Page {
  contentData: ContentData;

  constructor(props: PageType) {
    super(props);
    this.contentData = props.contentData;
  }

  get privacyPolicy() {
    return this.contentData.policy;
  }

  get createAccountPrivacyPolicy() {
    return this.contentData.create_account_policy;
  }

  get shippingMethods() {
    return this.contentData.shipping_methods;
  }

  get createAccountUsps() {
    return this.contentData.create_account_usps;
  }

  get crossSell() {
    return this.contentData.cross_sell;
  }

  get charityText() {
    return this.contentData.group_charity_text;
  }

  get charityFlyoutText() {
    return this.contentData.group_charity_flyout_text;
  }

  get charityTitle() {
    return this.contentData.group_charity_title;
  }

  get helpText() {
    return this.contentData.help_text;
  }
  get newsletter_signup() {
    return this.contentData.newsletter_signup;
  }
}
